export const loadingSelector = (state) => state.heroBanner.loading;
export const dataSelector = (state) => state.heroBanner.data;
export const errorsSelector = (state) => state.heroBanner.errors;
